<template>
<div class="quizstatus_check">	
  <template v-if="$store.state.evaluation.viewingmode=='admin_viewing'">
    <Button :label="$store.state.languages.lang_phrases.duzenleme_modu" class="p-button-outlined p-button-primary p-button-sm"  icon="pi pi-pencil" @click="enterEditingMode" :loading="$store.state.ui.submitting"/>
  </template>

  <template v-if="$store.state.evaluation.viewingmode=='admin_submitting'">
    <template v-if="!is_planner">
      <Button :label="$store.state.languages.lang_phrases.tamamla" class="p-button-outlined p-button-primary p-button-sm"  icon="pi pi-check" @click="checkQuizQuestions" :loading="$store.state.ui.submitting"/>
    </template>
    
    
    <template v-if="this.$store.state.audit.audit.status=='finished' || this.$store.state.audit.audit.status=='under_review'">
      <Button :label="$store.state.languages.lang_phrases.duzeltme_modundan_cik" class="p-button-outlined p-button-primary p-button-sm ml-2"  icon="pi pi-pencil" @click="exitEditingMode" :loading="$store.state.ui.submitting"/>
    </template>

  </template>

  <template v-if="$store.state.evaluation.viewingmode=='viewing'">
    <template v-if="$store.state.evaluation.evaluation.status=='correction_requested'">
     <p class="text-blue-500">{{$store.state.languages.lang_phrases.duzeltme_talebi_incelemede}}</p>
    </template>
    <template v-else>
      <template v-if="$store.state.evaluation.evaluation.flow.id== $store.state.evaluation.evaluation.project_supplier.activeflow_id">
        
      <Button :label="$store.state.languages.lang_phrases.duzeltme_talebi_gonder" class="p-button-outlined p-button-primary p-button-sm"  icon="pi pi-lock-open" @click="sendCorrectionRequest" :loading="$store.state.ui.submitting"/>
      </template>
    </template>    
  </template>

  <template v-if="$store.state.evaluation.viewingmode=='submitting'">
    <Button :label="$store.state.languages.lang_phrases.tamamla" class="p-button-outlined p-button-primary p-button-sm"  icon="pi pi-check" @click="checkQuizQuestions" :loading="$store.state.ui.submitting"/>
  </template>




</div>
</template>

<script>
export default {
  name: 'QuizStatusChanger',

  data () {
    return {

    }
  },
  computed:{
    is_planner()
    {
        let roles = this.$store.state.auth.userroles
        if(roles.includes("planner"))
        {
          if(roles.includes("admin") || roles.includes("auditor") || roles.includes("technical_auditor"))
          {            
            return false
          }
          return true
            
        }
        return false
    },
  },
  methods:{
    sendCorrectionRequest()
    {
      let formdata = new FormData()
      this.generalSubmission(formdata,"audit/request_correction/"+this.$route.params.id,this.aftersendCorrectionRequest)
    },
    aftersendCorrectionRequest(response)
    {
      console.log(response.data)
      this.$store.dispatch('evaluation/setEvaluation',response.data) 
      this.showMessage("success","","Düzeltme Talebiniz İletildi")
    },
    async checkQuizQuestions()
    {
      console.log(this.$store.state.evaluation.viewingmode)
      

      let attribute_status = await this.checkCustomAttributesReadyToFinish()
      if(!attribute_status)
      {
        await this.$router.push({ name: 'AuditCover' })
        this.showMessage("error",this.$store.state.languages.lang_phrases.lutfen_gerekli_alanlari_doldurun,"")
        return false
      }

      let status = await this.checkReadyToFinish()
      
      if(!status)
      {
        let inputfield = await this.$store.state.evaluation.first_inputfield_error
        await this.$store.dispatch('evaluation/setFinishError',true)
        await console.log(inputfield)
        let parentsections = await this.$store.state.audit.questionlist.inputfieldsections.filter((item)=>{return item.parent_id == 0})
        await this.$router.push({ name: 'AuditQuestionListSection', params: { section_id:inputfield.inputfieldsection_id } })
        
      }
      else
      {
        await this.$store.dispatch('evaluation/setShowFinishModal',true)
      }
      //return false
      //this.generalSubmission(formdata,"audit/finish_selt_evaluation/"+this.$route.params.id,this.aftercheckQuizQuestions)
    },
    aftercheckQuizQuestions(response)
    {
      console.log(response.data)
    },
    enterEditingMode()
    {
      //let inputfields = this.sanitizeArray(this.$store.state.evaluation.inputfields)
      for(let inputfield of this.$store.state.evaluation.inputfields)
      {
        inputfield.read_only_state = false
      }
      //this.$store.dispatch('evaluation/setInputfields',inputfields)
      this.$store.dispatch('evaluation/setMode',"admin_submitting") 
    },

    exitEditingMode()
    {
      //let inputfields = this.sanitizeArray(this.$store.state.evaluation.inputfields)
      for(let inputfield of this.$store.state.evaluation.inputfields)
      {
        inputfield.read_only_state = true
      }
      //this.$store.dispatch('evaluation/setInputfields',inputfields)
      this.$store.dispatch('evaluation/setMode',"admin_viewing") 
    },
  }
}
</script>

<style lang="css" scoped>
</style>